import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ctx from 'classnames';

import SxIcon from '../common/sxIcon';
import selectQuestionsVariables from '../../store/selectors/selectQuestionsVariables/selectQuestionsVariables';

import styles from './variablesViewer.module.scss';

class VariablesViewer extends Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(window.location.search);
    const isCustomize = queryParams.get('customize');
    const matrixEasterEgg = queryParams.has('matrix');
    this.state = {
      open: false,
      variableValuesChanged: this.getInitialVariablesValues(props),
      matrixEasterEgg,
      isCustomize,
    };
    this.onToggleOpenClick = this.onToggleOpenClick.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.open !== this.state.open || prevState.variableValuesChanged !== this.state.variableValuesChanged) {
      return;
    }
    const { variables = {} } = this.props;
    const prevValues = this.getVariablesValues(prevProps);
    const values = this.getVariablesValues(this.props);
    const variableValuesChanged = {};
    Object.keys(variables).forEach((variableId) => {
      variableValuesChanged[variableId] = prevValues[variableId] !== values[variableId];
    });
    this.setState({ variableValuesChanged });
  }
  getInitialVariablesValues(props) {
    const { variables = {} } = props;
    const variableValues = {};
    Object.keys(variables).forEach((variableId) => {
      variableValues[variableId] = false;
    });
    return variableValues;
  }
  getVariablesValues(props) {
    const { variables = {}, surveyVariables = {} } = props;
    const variableValues = {};
    Object.keys(variables).forEach((variableId) => {
      variableValues[variableId] = this.getValue(surveyVariables[variableId]);
    });
    return variableValues;
  }
  getValue(variableValues) {
    if (!variableValues || variableValues.values.length === 0) {
      return '----';
    }
    const lastIndex = variableValues.values.length - 1;
    return variableValues.values[lastIndex];
  }
  onToggleOpenClick() {
    this.setState((prevState) => ({ open: !prevState.open }));
  }
  getLastValue(variableValues) {
    if (!variableValues || variableValues.values.length === 0) {
      return <span className={styles.noValueSet}>----</span>;
    }
    const lastIndex = variableValues.values.length - 1;
    return variableValues.values[lastIndex];
  }
  renderVariable(variable, variableId) {
    const { surveyVariables = {} } = this.props;
    const { variableValuesChanged } = this.state;
    return (
      <div key={variableId} className={styles.variable}>
        <div className={styles.name}>{variable.name}</div>
        <div className={ctx(styles.value, { [styles.changed]: variableValuesChanged[variableId] })}>
          {this.getLastValue(surveyVariables[variableId])}
        </div>
      </div>
    );
  }
  renderVariables() {
    const { variables = {} } = this.props;
    return Object.keys(variables).map((variableId) => {
      const variable = variables[variableId];
      return this.renderVariable(variable, variableId);
    });
  }
  render() {
    const { variables = {} } = this.props;
    const { matrixEasterEgg = false, isCustomize = false } = this.state;
    if (Object.keys(variables).length === 0 || isCustomize) {
      return null;
    }
    const { open } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.headerContainer} onClick={this.onToggleOpenClick}>
          <div className={styles.header}>Variables Viewer</div>
          <div>
            <SxIcon name={open ? 'sx-down' : 'sx-up'} color="white" />
          </div>
        </div>
        <div className={ctx(styles.variables, { [styles.open]: open, [styles.matrix]: matrixEasterEgg })}>
          {this.renderVariables()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { surveyVariables } = state;
  const questionsVariables = selectQuestionsVariables(state);
  return {
    variables: questionsVariables,
    surveyVariables,
  };
};

export default connect(mapStateToProps)(VariablesViewer);
